module.exports = __webpack_public_path__ + "img/business-solutions-hero-mobile.66eb431d.png";